import { useRef, useState, useEffect } from 'react';

import { Filter } from 'vindi-ds-components';

import api from '@services/api';

import listData from '../../utils/list_data';

import { quick as schemaQuick, advanced as schemaAdvanced } from './schema.json';

function ransackFormat(params) {
  const formatedParams = [];

  Object.keys(params).forEach((key) => {
    const newKey = `q[${key}]`;
    formatedParams[newKey] = params[key];
  });

  return formatedParams;
}

async function listCharges(params) {
  const request = await api.get('/admin/reports/charges_v2', ransackFormat(params));

  const charges = listData(request?.data.charges, params);
  const data = request?.data.totals;

  return {
    ...data,
    charges,
    totalCount: request?.data.charges.length,
  };
}

const pagination = {
  enabled: true,
  perPage: 20,
  getCount: async (query) => query?.data?.totalCount,
};

function useFilterCharges() {
  const [filterFields, setFilterFields] = useState(null);

  useEffect(() => {
    api.get('/admin/reports/filters_parameters_by_report', { report: 'charges_report' }).then((response) => {
      setFilterFields(response?.data?.charges_filter?.fields);
    });
  }, []);

  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: 'charges',
      queryFn: listCharges,
    },
    filterOptions: {
      schemaQuick,
      schemaAdvanced,
      pagination,
    },
  });

  const modalDownloadRef = useRef();

  return {
    listing,
    modalDownloadRef,
    filterFields,
  };
}

export default useFilterCharges;
